import { checkIsStoryBookPath } from 'app/utils/check-is-story-book-path';

export const URI_PREFIX = checkIsStoryBookPath('archive');
const URI_PREFIX_SETTINGS = checkIsStoryBookPath('settings');
export const apiRoutes = {
  // Tags Table API
  allTagsArchive: `${URI_PREFIX}/tags/all`,
  trashedTagsArchive: `${URI_PREFIX}/tags/trashed`,
  trashTags: `${URI_PREFIX}/tags/trash`,
  restoreTags: `${URI_PREFIX}/tags/restore`,
  deleteTags: `${URI_PREFIX}/tags/delete`,

  // Categories Table API
  allCategoriesArchive: `${URI_PREFIX}/categories/all`,
  trashedCategoriesArchive: `${URI_PREFIX}/categories/trashed`,
  trashCategories: `${URI_PREFIX}/categories/trash`,
  restoreCategories: `${URI_PREFIX}/categories/restore`,
  deleteCategories: `${URI_PREFIX}/categories/delete`,
  addCategory: `${URI_PREFIX}/categories/store`,
  editCategory: `${URI_PREFIX}/categories/update`,
  // Groups Table API
  allGroupsArchive: `${URI_PREFIX}/groups/all`,
  trashedGroupsArchive: `${URI_PREFIX}/groups/trashed`,
  trashGroups: `${URI_PREFIX}/groups/trash`,
  restoreGroups: `${URI_PREFIX}/groups/restore`,
  deleteGroups: `${URI_PREFIX}/groups/delete`,
  addGroup: `${URI_PREFIX}/groups/store`,
  updateGroup: `${URI_PREFIX}/groups/update`,
  updateReportVersions: `${URI_PREFIX}/items/versions/update`,
  cloneReportVersions: `${URI_PREFIX}/items/versions/clone`,

  //Items Table API
  allItemsArchive: `${URI_PREFIX}/items/all`,
  trashedItemsArchive: `${URI_PREFIX}/items/trashed`,
  activeItemsArchive: `${URI_PREFIX}/items/active`,
  inActiveItemsArchive: `${URI_PREFIX}/items/in-active`,
  todoItemsArchive: `${URI_PREFIX}/items/to-do`,
  itemsPriorityArchive: `${URI_PREFIX}/items/priorities/all`,
  itemsFrequencyArchive: `${URI_PREFIX}/items/frequencies/all`,
  trashItems: `${URI_PREFIX}/items/trash`,
  restoreItems: `${URI_PREFIX}/items/restore`,
  deleteItems: `${URI_PREFIX}/items/delete`,
  addItem: `${URI_PREFIX}/items/store`,
  editItem: `${URI_PREFIX}/items/update`,

  getItemCategories: `${URI_PREFIX}/items/categories`,
  getItemTags: `${URI_PREFIX}/items/tags`,
  getItemGroups: `${URI_PREFIX}/items/groups`,
  getItemReporters: `${URI_PREFIX}/items/reporters`,

  //Item Details Page
  itemsDetails: `${URI_PREFIX}/items/show`,
  reportAutocomplete: `${URI_PREFIX}/items/versions/all`,
  reportTab: `${URI_PREFIX}/items/versions/all`,
  trashItem: `${URI_PREFIX}/items/versions/trash`,
  deleteItem: `${URI_PREFIX}/items/versions/delete`,
  restoreItem: `${URI_PREFIX}/items/versions/restore`,
  trashedTab: `${URI_PREFIX}/items/versions/trashed`,
  trashedAutocomplete: `${URI_PREFIX}/items/versions/trashed`,
  followAction: `${URI_PREFIX}/items/follow`,
  unFollowAction: `${URI_PREFIX}/items/un-follow`,
  addNewReport: `${URI_PREFIX}/items/versions/store`,
  versionsCount: `${URI_PREFIX}/items/versions/count`,
  uploadFilesCount: `${URI_PREFIX}/items/files/uploaded/count`,
  reportCount: `${URI_PREFIX}/items/reports/count`,
  allCountries: `${URI_PREFIX_SETTINGS}/countries/all`,
  preSignedUrl: `${URI_PREFIX_SETTINGS}/pre-signed/url`,

  //Dashboard
  totalItems: `${URI_PREFIX}/items/all/count`,
  activeItems: `${URI_PREFIX}/items/active/count`,
  inactiveItems: `${URI_PREFIX}/items/in-active/count`,
  todoItems: `${URI_PREFIX}/items/to-do/count`,
  uploadedReports: `${URI_PREFIX}/items/versions/all/count`,
  tagsCount: `${URI_PREFIX}/tags/all/count`,
  categoriesCount: `${URI_PREFIX}/categories/all/count`,
  totalGroupsCount: `${URI_PREFIX}/groups/all/count`,
  topUsedTags: `${URI_PREFIX}/tags/top-used`,
  itemsCategoriesChart: `${URI_PREFIX}/category/items/count`,
  itemsGroupsChart: `${URI_PREFIX}/group/items/count`,
};
